<template>
    <v-data-table
        v-if="items"
        fixed-header
        :headers="currentReportHeaders"
        :items="items"
        :loading="loading"
        :items-per-page="10"
        :hide-default-footer="false"
        :footer-props="{
            'items-per-page-options': [15, 30, 50, -1],
            'items-per-page-text': t('datatable::pagination.items.per.page.text'),
        }"
    >
        <template #[`item.patient.dms_id`]="{ item }">
            <div
                v-if="item.patient?.dms_id && can('patients.preview')"
                class="link"
                @click="$root.goTo(patientsItemUrl(item.patient))"
            >
                {{ item.patient?.dms_id ?? t('patients::label.deleted') }}
            </div>
            <div v-else>
                {{ item.patient?.dms_id ?? t('patients::label.deleted') }}
            </div>
        </template>
        <template #[`item.blood_1.date_received`]="{ item }">
            <div v-if="item.blood_1" :class="`blood-status ${item.blood_1.color_result}--text`">
                <div :class="`status ${item.blood_1.color_result}--text`">
                    <v-icon>icon icon-blood-result</v-icon>
                </div>
                <span
                    v-text="
                        item.blood_1.date_received
                            ? moment(item.blood_1.date_received).format($root.dateFormat)
                            : t('default::label.na')
                    "
                ></span>
            </div>
            <div v-else>
                <span>{{ t('default::label.na') }}</span>
            </div>
        </template>
        <template #[`item.date_received_day_4`]="{ item }">
            {{
                item.date_received_day_4
                    ? moment(item.date_received_day_4).format($root.dateFormat)
                    : t('default::label.na')
            }}
        </template>
        <template #[`item.blood_2.date_received`]="{ item }">
            <div v-if="item.blood_2" :class="`blood-status ${item.blood_2.color_result}--text`">
                <div :class="`status ${item.blood_2.color_result}--text`">
                    <v-icon>icon icon-blood-result</v-icon>
                </div>
                <span
                    v-text="
                        item.blood_2.date_received
                            ? moment(item.blood_2.date_received).format($root.dateFormat)
                            : t('default::label.na')
                    "
                ></span>
            </div>
            <div v-else>
                <span>{{ t('default::label.na') }}</span>
            </div>
        </template>
        <template #[`item.blood_3.date_received`]="{ item }">
            <div v-if="item.blood_3" :class="`blood-status ${item.blood_3.color_result}--text`">
                <div :class="`status ${item.blood_3.color_result}--text`">
                    <v-icon>icon icon-blood-result</v-icon>
                </div>
                <span
                    v-text="
                        item.blood_3.date_received
                            ? moment(item.blood_3.date_received).format($root.dateFormat)
                            : t('default::label.na')
                    "
                ></span>
            </div>
            <div v-else>
                <span>{{ t('default::label.na') }}</span>
            </div>
        </template>
        <template #[`item.blood_4.date_received`]="{ item }">
            <div v-if="item.blood_4" :class="`blood-status ${item.blood_4.color_result}--text`">
                <div :class="`status ${item.blood_4.color_result}--text`">
                    <v-icon>icon icon-blood-result</v-icon>
                </div>
                <span
                    v-text="
                        item.blood_4.date_received
                            ? moment(item.blood_4.date_received).format($root.dateFormat)
                            : t('default::label.na')
                    "
                ></span>
            </div>
            <div v-else>
                <span>{{ t('default::label.na') }}</span>
            </div>
        </template>
        <template #[`item.emailed_pv`]="{ item }">
            <v-edit-dialog :ref="`editDialogPv${item.id}`" @save="saveItemRow(item)">
                <v-icon left>mdi-pencil</v-icon
                ><span class="grid-editable"> {{ item.emailed_pv || t('default::label.na') }} </span>
                <template #input>
                    <div class="form-minutes">
                        <div class="input-textarea">
                            <v-textarea
                                :ref="`editDialogInputPv${item.id}`"
                                v-model="item.emailed_pv"
                                :label="t('reports::trackers.grid.label.emailed_pv')"
                                dense
                                outlined
                                rounded
                            ></v-textarea>
                        </div>
                        <div class="input-actions pt-4">
                            <v-tooltip top transition="v-fab-transition">
                                <template #activator="{ on, attrs }">
                                    <v-btn color="primary" icon v-bind="attrs" v-on="on" @click="fakeSaveItemRow(item)">
                                        <v-icon>mdi-check</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ t('default::button.save') }}</span>
                            </v-tooltip>
                            <v-tooltip top transition="v-fab-transition">
                                <template #activator="{ on, attrs }">
                                    <v-btn
                                        color="disabled-color"
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="closeDialog(item)"
                                    >
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ t('default::button.close') }}</span>
                            </v-tooltip>
                        </div>
                    </div>
                </template>
            </v-edit-dialog>
        </template>
    </v-data-table>
</template>

<script>
export default {
    name: 'AmberResultsDataTable',
    components: {},
    data() {
        return {
            hiddenColumns: ['id'],
        };
    },
    computed: {
        loading: {
            get() {
                return this.$store.state.trackers.loading;
            },
            set(loading) {
                return this.$store.dispatch('trackers/setLoading', loading);
            },
        },
        currentReportHeaders() {
            const columns = [
                {
                    text: t('reports::trackers.grid.label.id'),
                    value: 'id',
                    sortable: false,
                    width: 170,
                },
                // {
                //     text: t('reports::trackers.grid.label.completed_by'),
                //     value: 'completed_by',
                //     sortable: true,
                //     width: 200,
                // },
                {
                    text: t('reports::trackers.grid.label.patient_id'),
                    value: 'patient.dms_id',
                    fields: 'patient',
                    sortable: true,
                    width: 120,
                },
                {
                    text: t('reports::trackers.grid.label.blood_1'),
                    value: 'blood_1.date_received',
                    fields: 'blood_1',
                    sortable: true,
                    width: 180,
                },
                {
                    text: t('reports::trackers.grid.label.date_received_day_4'),
                    value: 'date_received_day_4',
                    sortable: true,
                    width: 180,
                },
                {
                    text: t('reports::trackers.grid.label.blood_2'),
                    value: 'blood_2.date_received',
                    fields: 'blood_2',
                    sortable: true,
                    width: 180,
                },
                {
                    text: t('reports::trackers.grid.label.blood_3'),
                    value: 'blood_3.date_received',
                    fields: 'blood_3',
                    sortable: true,
                    width: 180,
                },
                {
                    text: t('reports::trackers.grid.label.blood_4'),
                    value: 'blood_4.date_received',
                    fields: 'blood_4',
                    sortable: true,
                    width: 180,
                },

                {
                    text: t('reports::trackers.grid.label.emailed_pv'),
                    value: 'emailed_pv',
                    sortable: true,
                    align: 'center',
                    width: 300,
                },
            ];
            return columns.filter((x) => !this.hiddenColumns.includes(x.value));
        },
        items() {
            return this.$store.state.trackers.currentReportItems;
        },
    },
    watch: {},
    mounted() {},
    methods: {
        closeDialog(item) {
            const dialog = this.$refs[`editDialogPv${item.id}`];
            if (dialog) {
                dialog.$emit('close');
                dialog.isActive = false;
            }
        },
        fakeSaveItemRow(item) {
            this.$refs[`editDialogPv${item.id}`].save(item.emailed_pv);
            this.$refs[`editDialogPv${item.id}`].$emit('save');
        },
        saveItemRow(item) {
            const data = {
                data: {
                    id: item.id,
                    emailed_pv: item.emailed_pv,
                },
            };
            axios
                .put(route('api.v1.trackers.amber-results.update'), { data })
                .then(() => {
                    this.$root.notify(
                        'info',
                        t('default::notification.success'),
                        t('reports::trackers.mhbu.item.updated')
                    );
                })
                .catch((error) => {
                    this.$root.notify('error', error.response.data.error);
                });
        },
        patientsItemUrl(item) {
            return route('patients.preview', { id: item.id });
        },
    },
};
</script>
